const cartSummary = {
  initialize() {
    this.itemTemplate = $('#summary-item').html();

    $(document).on('cart:update', () => {
      this.fetchCart()
        .then((data) => {
          this.updateExtrasSelector(data);
        });
    });
  },

  /**
   * Fetch the cart from the API
   * @return {Promise}
   */
  fetchCart() {
    return new Promise((resolve) => {
      $.ajax({
        url: window.app.api.cart,
        success: resolve,
      });
    });
  },

  /**
   * Update the extra's selector on product detail
   * @param {Object} data
   * @return {void}
   */
  updateExtrasSelector(data) {
    const $extrasSelector = $('.js-summary-extras-selector');
    const $text = $('.js-summary-extras-selector-text');

    if (typeof data.items === 'undefined' || !data.items.length) {
      return;
    }

    const count = data.items.reduce((accumulator, item) => (
      item.is_package ? accumulator : accumulator + 1
    ), 0);

    if ($extrasSelector.length && $text.length) {
      $extrasSelector.addClass('has-packages-selected');
      $text.html(`${count} extra&rsquo;s geselecteerd`);
    }
  },
};

export default cartSummary;
